<script setup lang="ts">
const { isVisible, confirm, cancel } = useConfirmDialog()

const saving = ref(false)

async function save() {
  saving.value = true
  await saveAllDirtyForm()
  saving.value = false

  if (Object.entries(dirtyFlags.value).length > 0) {
    cancel()
  }
  else {
    confirm()
  }
}
</script>

<template>
  <UModal v-model="isVisible" :ui="{ base: 'overflow-visible' }" prevent-close>
    <UCard :ui="{ base: 'overflow-visible' }">
      <template #header>
        <div class="flex justify-between items-center">
          <h3 class="text-lg font-semibold text-gray-900">Änderung speichern</h3>
          <UButton color="white" variant="link" icon="i-tabler-x" :disabled="saving" @click="() => cancel()" />
        </div>
      </template>
      <div class="flex flex-col gap-4">
        <div class="flex justify-between">
          <p>Möchtest Du Deine Änderungen speichern?</p>
        </div>
        <div class="flex gap-2">
          <UButton
            class="flex-1"
            label="Verwerfen"
            icon="i-ph-x-bold"
            variant="soft"
            :disabled="saving"
            @click="
              () => {
                clearAllDirtyForm()
                confirm()
              }
            "
          />
          <UButton
            class="flex-1"
            label="Speichern"
            icon="i-ph-arrow-right-bold"
            :loading="saving"
            @click="() => save()"
          />
        </div>
      </div>
    </UCard>
  </UModal>
</template>
